
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enquiry",
      function () {
        return require("private-next-pages/enquiry/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enquiry"])
      });
    }
  